var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"reload-button",class:{loading: _vm.loading},on:{"click":function($event){return _vm.reload()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }